import { Box, styled, Typography } from '@mui/material';
import AppModal from 'components/AppModal';
import SearchArea from './search-area';
import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axios';

// styled components
const StyledAppModal = styled(AppModal)(() => ({
    top: 0,
    left: 0,
    padding: 0,
    width: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100vh',
    borderRadius: 0,
    position: 'absolute',
    transform: 'none',
    backgroundColor: 'transparent',
}));

const FormCheckin = ({ open, onClose, data }) => {
    const [responseName, setResponseName] = useState(null);
    const [payload, setPayload] = useState({
        checkinDate: null,
        qrCode: null,
        room: null,
        name: null,
    });

    useEffect(() => {
        setPayload(() => ({
            qrCode: null,
            room: data?.value,
            name: data?.label,
        }));
    }, [open, data]);

    const clearQrCode = () => {
        setPayload((prevPayload) => ({
            ...prevPayload,
            qrCode: null,
        }));
    };

    const clearResponseNameWithDelay = () => {
        setTimeout(() => {
            setResponseName(null);
        }, 5000);
    };

    const onEnter = async () => {
        try {
            const { data: responseData } = await axiosInstance.post(
                'api/prv/checkin-logs',
                payload,
            );
            setResponseName(responseData?.name ?? null);
        } catch (error) {
            clearQrCode();
            setResponseName('Not Found');
            return;
        } finally {
            clearResponseNameWithDelay();
            clearQrCode();
        }
    };

    const handleSearch = (value) => {
        setPayload((prevPayload) => ({
            ...prevPayload,
            qrCode: value,
        }));
    };
    return (
        <StyledAppModal open={open} handleClose={onClose}>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundImage: 'url(/assets/checkin-background.webp)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: { xs: 100, sm: 120, md: 140 },
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '100%',
                        maxWidth: 720,
                        px: 2,
                    }}
                >
                    <SearchArea
                        value={payload.qrCode}
                        onChange={handleSearch}
                        onEnter={onEnter}
                    />
                </Box>

                {!!responseName && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            px: 2,
                            textAlign: 'center',
                        }}
                    >
                        <Typography
                            variant="h1"
                            fontWeight={800}
                            sx={{
                                color: '#111',
                                textShadow:
                                    '0 2px 12px rgba(255, 255, 255, 0.85)',
                            }}
                        >
                            {responseName}
                        </Typography>
                    </Box>
                )}

                {!!data?.title && (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            bottom: 190,
                            px: { xs: 2, sm: 3 },
                            py: { xs: 2, sm: 2.5 },
                            textAlign: 'center',
                        }}
                    >
                        <Typography variant="h1" fontWeight={700}>
                            {data.title}
                        </Typography>
                    </Box>
                )}
            </Box>
        </StyledAppModal>
    );
};

export default FormCheckin;
